import React from 'react';
import { Redirect } from '@reach/router';
import { withPrefix } from 'gatsby';

/** Permanent URL is /svenska-tjanster; this page keeps old links working. */
export default function SwedishServicesRedirect() {
  return <Redirect to={withPrefix('/svenska-tjanster')} noThrow />;
}
